import React from "react";

import { Box, Chip, Typography } from "@mui/material";

const ACCENT = "#ed6c02";

interface MappingDynamicSourceProps {
    name?: string;
    mode?: string;
    fieldCount?: number;
}

const MappingDynamicSource: React.FC<MappingDynamicSourceProps> = ({
    name,
    mode,
    fieldCount = 0,
}) => {
    const displayName = name || "Unnamed Dynamic Value";

    return (
        <Box
            sx={{
                border: `1px solid ${ACCENT}`,
                px: 1.25,
                py: 1,
                borderRadius: "10px",
                display: "flex",
                alignItems: "center",
                gap: 1,
                width: "100%",
                minWidth: 0,
                backgroundColor: "rgba(237, 108, 2, 0.04)",
            }}
        >
            <Box sx={{ flex: 1, minWidth: 0 }}>
                <Typography
                    sx={{
                        fontWeight: 700,
                        fontSize: "13px",
                        color: "#856404",
                        fontFamily: '"Nunito", sans-serif',
                        mb: 0.25,
                    }}
                >
                    Dynamic Value
                </Typography>
                <Typography
                    noWrap
                    title={displayName}
                    sx={{
                        color: "#856404",
                        fontSize: "0.875rem",
                    }}
                >
                    {displayName}
                </Typography>
            </Box>
            <Chip
                label={
                    mode === "advanced" ? "Advanced" : `${fieldCount} fields`
                }
                size="small"
                sx={{
                    backgroundColor: ACCENT,
                    color: "white",
                    fontWeight: 600,
                    flexShrink: 0,
                }}
            />
        </Box>
    );
};

export default MappingDynamicSource;
